import styled from '@emotion/styled'
import { Stack, StackProps } from '@mui/material'
import Link from 'next/link'
import { NewFlexContainer } from 'components/common/common.style'
import { unifiedColors } from 'styles/colors'
import { themeUtils } from 'styles/theme'

export const OrganizerContainer = styled.div`
  border-radius: 20px;
  padding: 32px;
  background-color: ${unifiedColors.surface.subdued};

  ${themeUtils.maxWidth.sm} {
    padding: 17px 15px;
  }
`
export const BodyContainer = styled((props: StackProps) => (
  <Stack {...props} borderRadius={2.5} m="auto" gap={3} />
))``

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${unifiedColors.label.subdued};
  text-decoration: none;
  gap: 8px;
  &:hover {
    text-decoration: underline;
  }
`

export const OrganizerLinks = styled((props: StackProps) => (
  <Stack {...props} />
))``

export const PracticalInformationContent = styled(NewFlexContainer)``
